import React from "react";
import { Box, Typography, Grid, useTheme } from "@mui/material";
import { FaShieldAlt, FaHandshake, FaCertificate,FaSmileBeam,FaChartLine,FaCreditCard  } from "react-icons/fa";

const trustItems = [
  {
    title: "High-end Security",
    description: "All trades are protected with encryption and escrow for guaranteed safety.",
    icon: <FaShieldAlt size={40} />,
    color: "#F4C444", // yellow
  },
  {
    title: "Verified Members",
    description: "Every buyer and seller is thoroughly verified to ensure reliability.",
    icon: <FaHandshake size={40} />,
    color: "#4CAF50", // green
  },
  {
    title: "Guaranteed Payments",
    description: "Funds are held in escrow until the transaction is successfully completed.",
    icon: <FaCertificate size={40} />,
    color: "#2196F3", // blue
  },
  {
    title: "Transparent Deals",
    description: "Clear pricing, accurate listings, and full visibility at every step.",
    icon: <FaSmileBeam  size={40} />,
    color: "#FF9800", // blue
  },
  {
    title: "Global Network",
    description: "Connect with trusted scrap professionals across multiple countries.",
    icon: <FaChartLine size={40} />,
    color: "#9C27B0", // purple
  },
  {
    title: "Proven Track Record",
    description: "Thousands of successful trades completed with high satisfaction rates.",
    icon: <FaCreditCard size={40} />,
    color: "#009688", // teal
  }
];

const TrustAndCredibility = () => {
    const theme = useTheme();
  return (
    <Box sx={{ py: 10, px: 2, backgroundColor: "#fffef8" }}>
      <Typography
        variant="h3"
        align="center"
        fontWeight="bold"
        gutterBottom
        sx={{
          mb: 6,
          color: theme.palette.text.primary,
          fontSize: { xs: "2rem", md: "2.5rem" },
        }}
      >
        Why Trust Our Platform
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {trustItems.map((item, index) => (
          <Grid
            key={index}
            item
            xs={12}
            sm={6}
            md={4}
            display="flex"
            justifyContent="center"
          >
            <Box
              sx={{
                position: "relative",
                backgroundColor: "#fff",
                borderRadius: 3,
                border: "1px solid #eee",
                p: 4,
                textAlign: "center",
                maxWidth: 340,
                width: "100%",
                boxShadow: "0 5px 20px rgba(0,0,0,0.03)",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: `0 12px 40px ${item.color}50`,
                },
                "&:hover .iconBox": {
                  transform: "rotate(-10deg)",
                },
              }}
            >
              <Box
                className="iconBox"
                sx={{
                  width: 70,
                  height: 70,
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                  backgroundColor: item.color + "20",
                  color: item.color,
                  boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
                  transition: "transform 0.3s ease",
                }}
              >
                {item.icon}
              </Box>

              <Box
                sx={{
                  position: "absolute",
                  top: -12,
                  right: -12,
                  width: 38,
                  height: 38,
                  borderRadius: "50%",
                  backgroundColor: item.color,
                  color: "#fff",
                  fontSize: 14,
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 0 20px rgba(0,0,0,0.1)",
                }}
              >
                0{index + 1}
              </Box>

              <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                {item.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {item.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TrustAndCredibility;
